<div class="export-dialog-imr">
  <div>
    <p class="export-dialog-imr_title">
      {{ 'EXPORT_DIALOG_IMR.TITLE' | translate }}
    </p>

    <p
      class="export-dialog-imr_description"
      [innerHTML]="'EXPORT_DIALOG_IMR.DESCRIPTION' | translate: { email: email }"
    ></p>
  </div>

  <div class="export-dialog-imr__input">
    <fc-year-month-input
      requiredMark="true"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [control]="control"
      translateErrorPrefix="EXPORT_DIALOG_IMR.ERRORS"
    >
    </fc-year-month-input>
  </div>

  <div class="export-dialog-imr__buttons">
    <button
      mat-raised-button
      class="export-dialog-imr__buttons-button export-dialog-imr__buttons-button--white"
      [disabled]="isExporting"
      (click)="matDialogRef.close()"
    >
      {{ 'EXPORT_DIALOG_IMR.BUTTONS.CANCEL' | translate }}
    </button>

    <button
      mat-raised-button
      class="export-dialog-imr__buttons-button"
      [disabled]="isExporting || control.errors"
      (click)="export()"
    >
      {{ 'EXPORT_DIALOG_IMR.BUTTONS.EXPORT' | translate }}
    </button>
  </div>
</div>
